/* 表示文言は layout/theme.liquid が定義する window.SoleilText から取る（既定は日本語） */
var SL_T = (typeof window !== 'undefined' && window.SoleilText) || {};
function slt(key, fallback) { return SL_T[key] || fallback; }

/* Soleil Levant — 商品ページ
   ・選択中のカラーに合わせてギャラリーの画像を絞り込む
   ・オプションの見出し右側に、選択中の値を出す
   画像とカラーの対応づけは、画像の代替テキスト（alt）に入れたカラー名で行う。
   alt が空の画像は共通画像として、どのカラーでも表示する。 */
(function () {
  'use strict';

  function selectedColor(gal) {
    var optName = gal.getAttribute('data-color-option');
    if (!optName) return '';
    var inputs = document.querySelectorAll('input[data-option-name][type="radio"]:checked, select[name^="options"] option:checked');
    for (var i = 0; i < inputs.length; i++) {
      var el = inputs[i];
      var name = el.getAttribute('data-option-name') || (el.parentElement && el.parentElement.getAttribute('name'));
      if (name && name.indexOf(optName) !== -1) return (el.value || el.textContent || '').trim();
    }
    return gal.getAttribute('data-selected-color') || '';
  }

  /* 画像の読み込みが終わってから差し替える。
     古い画像をゴースト層に写して上に重ね、新しい画像を敷いてから溶かして消すので、
     元画像の縦横比が違っていても、空白や一瞬の消失が出ない。 */
  function setMain(gal, thumb) {
    var main = gal.querySelector('[data-soleil-gal-main]');
    if (!main || !thumb) return;

    gal.querySelectorAll('.soleil-gal__thumb').forEach(function (t) {
      t.setAttribute('aria-current', t === thumb ? 'true' : 'false');
    });

    var src = thumb.getAttribute('data-full');
    var alt = thumb.getAttribute('data-alt') || '';
    if (!src) return;

    var current = main.getAttribute('src') || '';
    if (current === src) { main.alt = alt; return; }

    var ghost = gal.querySelector('[data-soleil-gal-ghost]');

    function apply() {
      if (!ghost || !current) {
        main.src = src;
        main.alt = alt;
        return;
      }
      ghost.classList.remove('is-fading');
      ghost.src = current;
      ghost.classList.add('is-on');
      main.src = src;
      main.alt = alt;
      requestAnimationFrame(function () {
        requestAnimationFrame(function () { ghost.classList.add('is-fading'); });
      });
      window.setTimeout(function () {
        ghost.classList.remove('is-on');
        ghost.classList.remove('is-fading');
      }, 760);
    }

    var pre = new Image();
    pre.src = src;
    if (pre.decode) { pre.decode().then(apply).catch(apply); }
    else if (pre.complete) { apply(); }
    else { pre.onload = apply; pre.onerror = apply; }
  }

  /* カラーごとの1枚目だけ先に読み込んでおく。切り替えの待ち時間をなくすため、
     全点ではなくカラー数ぶんに絞る。 */
  function prefetchFirstOfEachColor(gal) {
    var seen = {};
    gal.querySelectorAll('.soleil-gal__thumb').forEach(function (t) {
      var c = (t.getAttribute('data-color') || '').trim();
      var u = t.getAttribute('data-full');
      if (!c || !u || seen[c]) return;
      seen[c] = 1;
      var i = new Image();
      i.src = u;
    });
  }

  /* サムネイルに触れた時点で読み込んでおく */
  function prefetchOnHover(gal) {
    gal.querySelectorAll('.soleil-gal__thumb').forEach(function (t) {
      var done = false;
      function go() {
        if (done) return;
        done = true;
        var u = t.getAttribute('data-full');
        if (u) { var i = new Image(); i.src = u; }
      }
      t.addEventListener('pointerenter', go);
      t.addEventListener('focus', go);
    });
  }

  function refresh(gal) {
    var color = selectedColor(gal);
    var thumbs = Array.prototype.slice.call(gal.querySelectorAll('.soleil-gal__thumb'));
    var visible = [];

    thumbs.forEach(function (t) {
      var c = (t.getAttribute('data-color') || '').trim();
      // data-color が空 ＝ 全カラー共通の画像。
      var show = !color || !c || c === color;
      t.hidden = !show;
      if (show) visible.push(t);
    });

    // 選んだカラーの画像を先頭に持ってくる
    var preferred = visible.filter(function (t) {
      return color && (t.getAttribute('data-color') || '').trim() === color;
    })[0];
    setMain(gal, preferred || visible[0]);
    gal.classList.toggle('soleil-gal--single', visible.length < 2);
  }

  function syncPickedLabels() {
    document.querySelectorAll('.soleil-opt').forEach(function (fs) {
      var picked = fs.querySelector('[data-selected-value]');
      if (!picked) return;
      var checked = fs.querySelector('input[type="radio"]:checked');
      if (checked) picked.textContent = checked.value;
    });
  }


  /* お気に入り（端末のブラウザに保存。会員登録は不要） */
  var WISH_KEY = 'soleil-wishlist';

  function readWish() {
    try { return JSON.parse(localStorage.getItem(WISH_KEY) || '[]'); }
    catch (e) { return []; }
  }

  function writeWish(list) {
    try { localStorage.setItem(WISH_KEY, JSON.stringify(list)); } catch (e) {}
  }

  function initWish() {
    var btn = document.querySelector('[data-soleil-wish]');
    if (!btn || btn.dataset.soleilBound === '1') return;
    btn.dataset.soleilBound = '1';

    var handle = btn.getAttribute('data-handle');
    var label = btn.querySelector('[data-soleil-wish-label]');

    function paint() {
      var on = readWish().indexOf(handle) !== -1;
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      if (label) label.textContent = on ? slt('wishAdded', 'お気に入りに追加済み') : slt('wishAdd', 'お気に入りに追加');
    }

    btn.addEventListener('click', function () {
      var list = readWish();
      var i = list.indexOf(handle);
      if (i === -1) { list.push(handle); } else { list.splice(i, 1); }
      writeWish(list);
      paint();
    });

    paint();
  }


  /* お気に入り一覧ページ */
  function yen(cents) {
    return '¥' + (cents / 100).toLocaleString('ja-JP');
  }

  // HTML に差し込む前のエスケープ。商品名に & " < > ' が含まれても壊れないようにする。
  function esc(v) {
    return String(v == null ? '' : v)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function cardHtml(p) {
    var img = p.featured_image
      ? p.featured_image.replace(/(\.[a-z]+)(\?|$)/i, '_600x$1$2')
      : '';
    var priceLabel = yen(p.price);
    if (p.price_varies) priceLabel = slt('priceFromPrefix', '') + priceLabel + slt('priceFromSuffix', 'から');
    return '<li class="soleil-fav__item">' +
      '<a href="/products/' + encodeURIComponent(p.handle) + '">' +
        '<span class="soleil-fav__fig">' +
          (img ? '<img src="' + esc(img) + '" alt="" loading="lazy">' : '') +
        '</span>' +
        '<span class="soleil-fav__name">' + esc(p.title) + '</span>' +
        '<span class="soleil-fav__price">' + esc(priceLabel) + '</span>' +
      '</a>' +
      '<button type="button" class="soleil-fav__remove" data-handle="' + esc(p.handle) + '">' + slt('wishRemove', 'お気に入りから外す') + '</button>' +
    '</li>';
  }

  function renderFavorites() {
    // ページ本文に置いた場合は data 属性が保存時に落ちるため、クラス名でも拾う
    var root = document.querySelector('[data-soleil-fav], .soleil-fav');
    if (!root) return;
    var list = root.querySelector('[data-soleil-fav-list], .soleil-fav__list');
    var empty = root.querySelector('[data-soleil-fav-empty], .soleil-fav__empty');
    var count = root.querySelector('[data-soleil-fav-count], .soleil-fav__count');
    if (!list || !empty) return;
    var handles = readWish();

    if (!handles.length) {
      list.innerHTML = '';
      empty.hidden = false;
      if (count) count.textContent = '';
      return;
    }
    empty.hidden = true;

    Promise.all(handles.map(function (h) {
      return fetch('/products/' + encodeURIComponent(h) + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    })).then(function (products) {
      var found = products.filter(Boolean);
      // 削除された商品や非公開になった商品は、保存からも外す
      if (found.length !== handles.length) {
        writeWish(found.map(function (p) { return p.handle; }));
      }
      if (!found.length) { empty.hidden = false; if (count) count.textContent = ''; return; }
      if (count) count.textContent = slt('countPrefix', '') + found.length + slt('countSuffix', '件');
      list.innerHTML = found.map(cardHtml).join('');
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.soleil-fav__remove');
    if (!btn) return;
    var list = readWish();
    var i = list.indexOf(btn.getAttribute('data-handle'));
    if (i !== -1) { list.splice(i, 1); writeWish(list); }
    renderFavorites();
  });

  function init() {
    initWish();
    renderFavorites();
    var gal = document.querySelector('[data-soleil-gal]');
    if (!gal) return;

    gal.addEventListener('click', function (e) {
      var thumb = e.target.closest('.soleil-gal__thumb');
      if (thumb) setMain(gal, thumb);
    });

    document.addEventListener('change', function (e) {
      if (e.target.closest && e.target.closest('variant-selects, .product-form__input')) {
        syncPickedLabels();
        refresh(gal);
      }
    });

    syncPickedLabels();
    refresh(gal);

    prefetchOnHover(gal);
    if (window.requestIdleCallback) {
      window.requestIdleCallback(function () { prefetchFirstOfEachColor(gal); });
    } else {
      window.setTimeout(function () { prefetchFirstOfEachColor(gal); }, 1200);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Dawn がセクションを差し替えたあとにも効かせる
  document.addEventListener('shopify:section:load', init);
})();
